import { render, staticRenderFns } from "./About.vue?vue&type=template&id=263eedd6&scoped=true"
var script = {}
import style0 from "./About.vue?vue&type=style&index=0&id=263eedd6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_3rwm2qttujvjuolkwtduiruple/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263eedd6",
  null
  
)

export default component.exports